import * as LightIcons from './lightIcons';
import * as SolidIcons from './solidIcons';

export { Icon } from './Icon';
export const IconList = { solid: SolidIcons, light: LightIcons };
